export class ErrorSub {
  message = ''

  draw = (
    c: CanvasRenderingContext2D,
    x: number,
    y: number,
  ) => {
    c.save()
    c.strokeStyle = c.fillStyle = '#f21'

    const fontSize = 11.9
    c.font = `italic 100 ${fontSize}px 'Jost', sans-serif`

    c.textBaseline = 'top'
    c.lineWidth = fontSize / 150

    c.fillText(
      this.message,
      x,
      y + 2,
    )

    c.strokeText(
      this.message,
      x,
      y + 2,
    )
    c.restore()
  }
}
